

































































































































































































































import { Component, Vue } from "vue-property-decorator";
import CartModule from "@/store/modules/tienda_cart_module";
import { CartHistory } from "@/shared/dtos/CartHistory";
import { TiendaCartHistoryLocalService } from "@/shared/services/tienda_cart_history_local_service";
import { RouterNames } from "@/router/routernames";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { ProcessoNums } from "../procesos/ProcessoNums";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";

@Component({})
export default class CartHistoryView extends Vue {
  private history: any[] = [];
  private snackbar: boolean = false;
  private snackbarText: string = "";
  private snackbarColor: string = "success";
  private searchQuery: string = "";
  private sortBy: string = "recent";
  private expandedCart: any = null;
  private deleteDialog: boolean = false;
  private clearAllDialog: boolean = false;
  private cartToDelete: any = null;
  private itemsVerificados: any[] = [];

  private sortOptions = [
    { text: "Más reciente", value: "recent" },
    { text: "Más antiguo", value: "oldest" },
    { text: "Mayor precio", value: "price-high" },
    { text: "Menor precio", value: "price-low" },
    { text: "Más artículos", value: "items-most" },
    { text: "Menos artículos", value: "items-least" },
  ];

  async mounted() {
    await this.loadHistory();
    await this.preloadEstados();
  }

  private safeItems(c: any): any[] {
    if (!c || !c.items || !(c.items instanceof Array)) return [];
    return c.items;
  }

  private safeTitle(prod: any): string {
    if (!prod) return "Producto";
    var t = (prod as any).titulo_producto;
    if (t && String(t).length > 0) return String(t);
    var n = (prod as any).name;
    if (n && String(n).length > 0) return String(n);
    return "Producto";
  }

  private safeImage(prod: any): string {
    if (!prod) return "";
    var l = (prod as any).large;
    return l ? String(l) : "";
  }

  private safePrecio(prod: any): number {
    if (!prod) return 0;
    var p: any = (prod as any).precio_venta;
    return Number(p || 0);
  }

  private lineTotal(it: any): number {
    var qty = Number(it && it.qty ? it.qty : 1);
    return this.safePrecio(it ? it.product : null) * qty;
  }

  private getTotalQty(cart: any): number {
    return this.safeItems(cart).reduce((sum, item) => sum + (item.qty || 1), 0);
  }

  private async loadHistory() {
    try {
      await CartModule.getAllCarts();
      this.history = CartModule.carts_loaded.map(function (h: any) {
        return h && typeof h.toPlain === "function" ? h.toPlain() : h;
      });
    } catch (e) {
      console.warn("loadHistory failed", e);
      this.history = [];
    }
  }

  get filteredHistory(): any[] {
    let filtered = [...this.history];

    // Search filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter((cart) => {
        const items = this.safeItems(cart.cart);
        return (
          items.some((item) =>
            this.safeTitle(item.product).toLowerCase().includes(query)
          ) ||
          (cart.cart.public_uid && String(cart.cart.public_uid).includes(query))
        );
      });
    }

    // Sort
    switch (this.sortBy) {
      case "oldest":
        filtered.sort(
          (a, b) =>
            new Date(a.cart.datecreated).getTime() -
            new Date(b.cart.datecreated).getTime()
        );
        break;
      case "price-high":
        filtered.sort(
          (a, b) => this.cartSubtotal(b.cart) - this.cartSubtotal(a.cart)
        );
        break;
      case "price-low":
        filtered.sort(
          (a, b) => this.cartSubtotal(a.cart) - this.cartSubtotal(b.cart)
        );
        break;
      case "items-most":
        filtered.sort(
          (a, b) =>
            this.safeItems(b.cart).length - this.safeItems(a.cart).length
        );
        break;
      case "items-least":
        filtered.sort(
          (a, b) =>
            this.safeItems(a.cart).length - this.safeItems(b.cart).length
        );
        break;
      default: // recent
        filtered.sort(
          (a, b) =>
            new Date(b.cart.datecreated).getTime() -
            new Date(a.cart.datecreated).getTime()
        );
    }

    return filtered;
  }

  private refresh() {
    this.loadHistory().then(() => {
      this.showSnack("Actualizado", "success");
      this.preloadEstados();
    });
  }

  private cartSubtotal(c: any): number {
    var items = this.safeItems(c);
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      sum += this.lineTotal(it);
    }
    return sum;
  }

  private formatPrice(v: any): string {
    var n = Number(v || 0);
    return n.toFixed(2);
  }

  private formatDate(val: any): string {
    if (!val) return "-";
    var d = new Date(val);
    if (isNaN(d.getTime())) return String(val);

    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return "Hoy";
    if (days === 1) return "Ayer";
    if (days < 7) return `Hace ${days} días`;
    if (days < 30) return `Hace ${Math.floor(days / 7)} semanas`;

    return d.toLocaleDateString("es-ES", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  private viewDetails(cart: any) {
    if (this.expandedCart === cart.id) {
      this.expandedCart = null;
    } else {
      this.expandedCart = cart.id;
    }
  }

  private showSnack(text: string, color: string = "success") {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }
  private verificado_item_sync(cart: any) {
    for (const it of this.safeItems(cart)) {
      // Cuando se selecciona un carrito verificado se incrementa en un 5% el precio de cada producto
      if (it && it.product) {
        const precio_venta = Number(it.product.precio_venta || 0);
        it.product.precio_venta = precio_venta * 1.05;
        // ✅ Evita clics posteriores
        if (!this.itemsVerificados.includes(cart.id)) {
          this.itemsVerificados.push(cart.id);
        }
      }
    }
  }

  private estadosProductos: Record<string, string> = {};

  private mapEstadoToText(estado: number | null | undefined): string {
    if (estado == null) return "Desconocido";
    switch (estado) {
      case ProcessoNums.Disponible:
        return "Disponible";
      case ProcessoNums.Reservado:
        return "Reservado";
      case ProcessoNums.VendidoEfectivo:
      case ProcessoNums.VendidoTarjeta:
        return "Vendido";
      case ProcessoNums.Devolucion:
        return "Devolución";
      case ProcessoNums.MermaRoto:
        return "Merma/Roto";
      case ProcessoNums.Envio:
        return "Envío";
      case ProcessoNums.PendientePago:
        return "Pendiente de pago";
      case ProcessoNums.Reparacion:
        return "En reparación";
      default:
        return "Desconocido";
    }
  }

  /** Carga en bloque los estados de todos los productos presentes en this.history */
  private async preloadEstados(): Promise<void> {
    const ids = new Set<string>();
    for (const h of this.history) {
      for (const it of this.safeItems(h.cart)) {
        const id = it.product.id;
        if (id) ids.add(String(id));
      }
    }

    // Evita peticiones repetidas: sólo pide los que no tenemos
    const pendientes = [...ids].filter((id) => !(id in this.estadosProductos));

    if (pendientes.length === 0) return;

    const tareas = pendientes.map(async (id) => {
      try {
        const x =
          await TiendaOnlineClientesModule.getTiendaOnlineClientesSilence(id);
        this.$set(this.estadosProductos, id, this.mapEstadoToText(x.estado));
      } catch (e) {
        console.warn("Estado falló para", id, e);
        this.$set(this.estadosProductos, id, "Desconocido");
      }
    });

    await Promise.allSettled(tareas);
  }

  private view_estado_item_sync(item: ProductoAmazon): string {
    const id = item.id;
    if (!id) return "Desconocido";
    return this.estadosProductos[id] || "Cargando…";
  }
}
